import React from "react";
import SupplierTable from "./supplier-table";


const Supplier = ({data}: any) => {
  return (
    <div>
      <SupplierTable data={data} />
    </div>
  );
};

export default Supplier;
